import React, { Component } from "react";
import { connect } from "react-redux";
import {
    UpdateProductsFilter,
    DisplayFilterMenu,
    ProductsListFilters,
    ProductsListType,
} from "../../../Redux/Actions/ProductListActions";
import { GetCategoriesList } from "../../../Redux/Actions/ProductListActions";
import {
    Button,
    Checkbox,
    Input,
    Accordion,
    CloseCircleIcon,
    CloseIcon,
    SearchIcon,
    AccordionDetails,
    AccordionSummary,
    Typography,
    FormControlLabel,
} from "@cin7/ui";

import "./Styles/_ProductsListBrandFilter.scss";

// Matches B2BService.Common.Services.Products.Models.NoBrandFilter.Id — the sentinel brandId
// that means "products with no brand set", not a real Global's id.
export const NO_BRAND_ID = -1;

interface componentProps {
    productsList: ProductsListType;
    identity: {
        uoms: string[];
    };
    auth: {
        subscribedToken: string;
    };
    UpdateProductsFilter: (filter: ProductsListFilters) => void;
    DisplayFilterMenu: (toggledByUser: boolean) => void;
}

interface componentState {
    brands: any[];
    brandIds: number[];
    brandSearchParameter: string;
    inStockFilter: boolean;
    outOfStockFilter: boolean;
    uomsFilter: string[];
}

class ProductsListBrandFilter extends Component<componentProps, componentState> {
    constructor(props: componentProps) {
        super(props);
        this.state = {
            brands: this.props.productsList.brands,
            brandIds: this.props.productsList.filter.brandIds,
            brandSearchParameter: "",
            inStockFilter: this.props.productsList.filter.inStockFilter,
            outOfStockFilter: this.props.productsList.filter.outOfStockFilter,
            uomsFilter: this.props.productsList.filter.uomsFilter,
        };
    }

    componentDidUpdate(prevProps: any) {
        // Closing without Apply (X icon or clicking outside) must discard any pending, unapplied
        // selections rather than leaving them in local state for the next time the panel opens.
        if (prevProps.productsList.filter.filterMenuOpen && !this.props.productsList.filter.filterMenuOpen) {
            this.setState({
                brands: this.props.productsList.brands,
                brandIds: this.props.productsList.filter.brandIds,
                brandSearchParameter: "",
                inStockFilter: this.props.productsList.filter.inStockFilter,
                outOfStockFilter: this.props.productsList.filter.outOfStockFilter,
                uomsFilter: this.props.productsList.filter.uomsFilter,
            });
            return;
        }

        if (prevProps.productsList.brands !== this.props.productsList.brands) {
            this.setState({
                brands: this.props.productsList.brands,
            });
        }

        if (prevProps.productsList.filter.brandIds !== this.props.productsList.filter.brandIds) {
            this.setState({
                brandIds: this.props.productsList.filter.brandIds,
            });
        }

        if (
            prevProps.productsList.filter.inStockFilter !== this.props.productsList.filter.inStockFilter ||
            prevProps.productsList.filter.outOfStockFilter !== this.props.productsList.filter.outOfStockFilter
        ) {
            this.setState({
                inStockFilter: this.props.productsList.filter.inStockFilter,
                outOfStockFilter: this.props.productsList.filter.outOfStockFilter,
            });
        }

        if (prevProps.productsList.filter.uomsFilter !== this.props.productsList.filter.uomsFilter) {
            this.setState({
                uomsFilter: this.props.productsList.filter.uomsFilter,
            });
        }
    }

    render() {
        const { productsList, identity } = this.props;
        const { brands, brandIds, brandSearchParameter, inStockFilter, outOfStockFilter, uomsFilter } = this.state;
        return (
            <>
                <div id="Filter-Sidebar" className={productsList.filter.filterMenuOpen ? "active" : ""}>
                    <div
                        id="Products-List-Brand-Filter"
                        className={`${productsList.filter.filterMenuOpen ? " active" : ""}`}
                    >
                        {productsList.filter.filterMenuOpen && (
                            <div className="products-filter">
                                <h2>Filter</h2>
                                <div
                                    className={"filter-close-icon"}
                                    onClick={() => this.props.DisplayFilterMenu(false)}
                                >
                                    <CloseIcon />
                                </div>

                                <div className="filter-action-buttons">
                                    <Button
                                        id={"Filter-Action-Apply"}
                                        className="filter-action-apply"
                                        onClick={this._applyFilter}
                                    >
                                        Apply Filter
                                    </Button>
                                    <Button
                                        id={"Filter-Action-Clear"}
                                        className="filter-action-clear"
                                        variant={"secondary"}
                                        onClick={this._clearFilter}
                                    >
                                        Clear
                                    </Button>
                                </div>
                                <div className="filters-heading">
                                    Filters<span>&nbsp;</span>
                                </div>
                                <div className="filters">
                                    <Accordion elevation={0} defaultExpanded>
                                        <AccordionSummary>
                                            <Typography variant={"h4"}>Availability</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="availability-filter filter">
                                                <FormControlLabel
                                                    value="top"
                                                    control={
                                                        <Checkbox
                                                            id={"Filter-In-Stock"}
                                                            checked={inStockFilter}
                                                            onChange={(_, checked) =>
                                                                this.setState({ inStockFilter: checked })
                                                            }
                                                        />
                                                    }
                                                    label={"In Stock"}
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value="top"
                                                    control={
                                                        <Checkbox
                                                            id={"Filter-Out-Of-Stock"}
                                                            checked={outOfStockFilter}
                                                            onChange={(_, checked) =>
                                                                this.setState({ outOfStockFilter: checked })
                                                            }
                                                        />
                                                    }
                                                    label={"Out of Stock"}
                                                    labelPlacement="end"
                                                />
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                    {productsList.brands.length > 0 ? (
                                        <Accordion elevation={0} defaultExpanded>
                                            <AccordionSummary>
                                                <Typography variant={"h4"}>Brand</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="brand-filter filter">
                                                    <Input
                                                        id={"Brand-Search-Box"}
                                                        className="brand-search-box"
                                                        onChange={(e) => this._onSearchBrand(e.target.value)}
                                                        value={brandSearchParameter}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <div className="input-icon">
                                                                    <SearchIcon />
                                                                </div>
                                                            ),
                                                            endAdornment: brandSearchParameter && (
                                                                <div
                                                                    className="input-icon"
                                                                    onClick={() => this._onSearchBrand("")}
                                                                >
                                                                    <CloseCircleIcon />
                                                                </div>
                                                            ),
                                                        }}
                                                    />
                                                    <div className="brands-list">
                                                        {brands.map((brand: any) => (
                                                            <FormControlLabel
                                                                key={brand.id}
                                                                value="top"
                                                                control={
                                                                    <Checkbox
                                                                        key={brand.id}
                                                                        id={brand.id.toString()}
                                                                        value={brand.id}
                                                                        checked={brandIds.includes(brand.id)}
                                                                        onChange={this._onChangeBrand}
                                                                    />
                                                                }
                                                                label={brand.name}
                                                                labelPlacement="end"
                                                            />
                                                        ))}
                                                        <FormControlLabel
                                                            key="no-brand"
                                                            value="top"
                                                            control={
                                                                <Checkbox
                                                                    id="Filter-Brand-None"
                                                                    value={NO_BRAND_ID}
                                                                    checked={brandIds.includes(NO_BRAND_ID)}
                                                                    onChange={this._onChangeBrand}
                                                                />
                                                            }
                                                            label="None"
                                                            labelPlacement="end"
                                                        />
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    ) : null}
                                    {identity.uoms?.length > 0 && (
                                        <Accordion elevation={0} defaultExpanded>
                                            <AccordionSummary>
                                                <Typography variant={"h4"}>Sold as</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="uom-filter filter">
                                                    {identity.uoms.map((uom: string) => (
                                                        <FormControlLabel
                                                            key={uom}
                                                            value="top"
                                                            control={
                                                                <Checkbox
                                                                    id={`Filter-Uom-${uom}`}
                                                                    checked={uomsFilter.includes(uom)}
                                                                    onChange={(_, checked) =>
                                                                        this._onChangeUom(uom, checked)
                                                                    }
                                                                />
                                                            }
                                                            label={uom}
                                                            labelPlacement="end"
                                                        />
                                                    ))}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }

    _clearFilter = () => {
        this.setState({
            brands: this.props.productsList.brands,
            brandIds: [],
            brandSearchParameter: "",
            inStockFilter: false,
            outOfStockFilter: false,
            uomsFilter: [],
        });

        this.props.UpdateProductsFilter({
            brandIds: [],
            inStockFilter: false,
            outOfStockFilter: false,
            uomsFilter: [],
        });
    };

    _applyFilter = () => {
        this.props.UpdateProductsFilter({
            brandIds: this.state.brandIds,
            inStockFilter: this.state.inStockFilter,
            outOfStockFilter: this.state.outOfStockFilter,
            uomsFilter: this.state.uomsFilter,
        });
        this.props.DisplayFilterMenu(false);
    };

    _onChangeUom = (uom: string, checked: boolean) => {
        this.setState((prevState) => ({
            uomsFilter: checked
                ? prevState.uomsFilter.concat(uom)
                : prevState.uomsFilter.filter((selected) => selected !== uom),
        }));
    };

    _onChangeBrand = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        var brands: number[] = [];

        if (checked) {
            brands.push(Number(e.target.value));

            this.setState({
                brandIds: this.state.brandIds.concat(brands),
            });
        } else {
            var currentBrandIds = this.state.brandIds.slice();
            var index = currentBrandIds.findIndex((x) => x.valueOf() === Number(e.target.value));
            currentBrandIds.splice(index, 1);

            brands = currentBrandIds;

            this.setState({
                brandIds: brands,
            });
        }
    };

    _onSearchBrand = (value: string | number) => {
        var brands: any[] = this.props.productsList.brands.filter((x: { name: string }) =>
            x.name.toLowerCase().includes(String(value).toLowerCase())
        );

        this.setState({
            brands: brands,
            brandSearchParameter: String(value),
        });
    };
}

const MapStateToProps = (state: { productListReducer: any; identityReducer: any; authReducer: any }) => ({
    productsList: state.productListReducer,
    identity: state.identityReducer,
    auth: state.authReducer,
});

export default connect(MapStateToProps, {
    UpdateProductsFilter,
    GetCategoriesList,
    DisplayFilterMenu,
})(ProductsListBrandFilter);
